import styled from 'styled-components';
import { Form, Select } from 'antd';

export const StyledForm = styled(Form)`
  textarea {
    min-height: 140px;
  }

  .ant-form-item {
    padding-bottom: 6px;

    .ant-form-item-label {
      font-weight: 600;

      & > label {
        font-size: 16px;
      }
    }
  }

  .ant-row {
    width: 100%;

    .ant-col-12 {
      width: 50%;
    }
  }
`;

export const StatusContainer = styled.div`
  padding: 10px 12px;
  display: flex;
  align-items: flex-start;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 8px;
`;
export const IconWrapper = styled.span`
  margin-right: 10px;
`;

export const StatusTitle = styled.div`
  color: rgb(0 0 0 / 88%);
  font-weight: 600;
  word-break: break-word;
  font-size: 14px;
  line-height: 20px;
`;
export const StatusContent = styled.div`
  color: rgb(0 0 0 / 45%);
  word-break: break-word;
  font-size: 14px;
  line-height: 20px;
`;

export const EmailsSelect = styled(Select)`
  .ant-select-selection-overflow {
    min-height: 60px;

    .ant-select-selection-overflow-item {
      align-self: flex-start;
    }
  }

  .ant-select-selection-placeholder {
    top: 14px;
  }
`;

export const ActionResponseTitle = styled.div`
  color: green;
  font-weight: 600;
  word-break: break-word;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 10px;

  .error {
    color: #ff4d4f;
  }
`;
